<template>
    <modal size="lg" @close="reset(); $emit('close')" :height-max="true" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Edit Insurance Plan</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">Company: </span>{{ company.name }}</div>
                    <div><span class="text-muted">Insurance Plan: </span>{{ insurancePlan.plan_name }}</div>
                </div>
            </div>

            <insurance-plan-form
                ref="planForm"
                :initial-value="formData"
                :show-plan-number="true"
            />

        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>

                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import InsurancePlanForm from './InsurancePlanForm'

export default {
    props: ['client', 'insurancePlan', ],
    mixins: [FormMixin, ModalMixin],
    components: {InsurancePlanForm, },
    emits: ['updated', 'close', ],
    data() {
        return {
            formData: this.makeFormData(),
        }
    },
    computed: {
        company() {
            return this.client.companies.find(c => c.id == this.insurancePlan.company_id)
        },
    },
    methods: {
        makeFormData() {
            return {
                plan_name: this.insurancePlan.plan_name,
                plan_type: this.insurancePlan.plan_type,
                is_pretax: this.insurancePlan.is_pretax,
                plan_number: this.insurancePlan.plan_number,
                starts_on: this.insurancePlan.starts_on,
                termination_mode: this.insurancePlan.termination_mode,
                has_hsa: this.insurancePlan.has_hsa,
                billing_type: this.insurancePlan.billing_type,
                employee_cost_covered: this.insurancePlan.employee_cost_covered,
                dependent_cost_covered: this.insurancePlan.dependent_cost_covered,
                age_determination_method: this.insurancePlan.age_determination_method,
                explicit_age_band_date: this.insurancePlan.explicit_age_band_date,
            }
        },
        onSubmit() {
            if (!this.$refs.planForm.validate()) {
                this.formErrors = this.$refs.planForm.formErrors
                return
            }

            const data = this.$refs.planForm.getFormData()

            this.$store.dispatch('START_LOADING')
            const url = `/clients/${this.client.id}/settings/insurance-plans/${this.insurancePlan.id}`
            this.$api.put(url, data).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo(`Successfully saved insurance plan details.`)
                this.$emit('updated', resp)
                this.close()
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.formErrors = (errors.__all__ || [])
                this.$bus.showError(errors.__all__)
            })
        }
    }
}
</script>
